import create from "zustand"
import presets from "./presets"
import modes from "./modes"
import * as Tone from "tone"
import { TweenMax, Sine, Linear, gsap, Back } from "gsap"
import * as THREE from 'three'
const synthAmt = 48
let startMode = 0
let shapes = 
[
    new THREE.ConeBufferGeometry(0.25, 1.6, 32),
    new THREE.CylinderBufferGeometry(0.075, 0.075, 2),
    new THREE.OctahedronBufferGeometry(0.2, 0, 0).scale(4,1,1),
    new THREE.BoxBufferGeometry(0.25, 0.25, 1),
    new THREE.DodecahedronBufferGeometry(0.3, 0, 0),
    new THREE.ConeBufferGeometry(0.25, 0.45, 32),
    new THREE.CylinderBufferGeometry(0.15, 0.15, 0.8, 32),
]
let startShape = 0
let startCursors = [] 
let startAngle = 4 


let samples = [{
    'A2' : 'scale-A2.[mp3|ogg]',
    'A3' : 'scale-A3.[mp3|ogg]',
    'C3' : 'scale-C3.[mp3|ogg]',
    'C4' : 'scale-C4.[mp3|ogg]',
    'D3' : 'scale-C3.[mp3|ogg]',
    'D4' : 'scale-D4.[mp3|ogg]',
    'E3' : 'scale-E3.[mp3|ogg]',
    'E4' : 'scale-E4.[mp3|ogg]',
    'G2' : 'scale-G2.[mp3|ogg]',
    'G3' : 'scale-G3.[mp3|ogg]',
}, {
    'attack' : 0.01,
    'release' : 0.9,
    'baseUrl' : './teropa/'
}]

let pannerL1 = new Tone.Panner(-0.8).toDestination()
let pannerL2 = new Tone.Panner(-0.6).toDestination()
let pannerL3 = new Tone.Panner(-0.2).toDestination()
let pannerR1 = new Tone.Panner(0.8).toDestination()
let pannerR2 = new Tone.Panner(0.6).toDestination()
let pannerR3 = new Tone.Panner(0.2).toDestination()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.volume.value = -20
synthR.volume.value = -20
synthL.connect(pannerL1)
synthL.connect(pannerL2)
synthL.connect(pannerL3)
synthR.connect(pannerR1)
synthR.connect(pannerR2)
synthR.connect(pannerR3)

const [useStore] = create((set, get) => ({
    amt: synthAmt,
    mode: startMode,
    angle: startAngle,
    polys: undefined,
    shape: startShape,
    cursor: new THREE.SphereBufferGeometry(0.03, 16,16),
    trackGeo: new THREE.CircleGeometry( 1, 64 ),
    cursorsAmt: startCursors.length,
    shapes,
    angles: [
        { name: '↖', position: {x:4, y:4, z:-4} },
        { name: '↑', position: {x:0, y:5, z:-5} },
        { name: '↗', position: {x:-4, y:4, z:-4} },
        { name: '←', position: {x:5, y:0, z:-5} },
        { name: ' ', position: {x:0, y:0, z:-7.5} },
        { name: '→', position: {x:-5, y:0, z:-5} },
        { name: '↘', position: {x:4, y:-4, z:-4} },
        { name: '↓', position: {x:0, y:-5, z:-5} },
        { name: '↙', position: {x:-4, y:-4, z:-4} },
    ],
    mut: {
        mouse: {x: 0, y: 0},
        data: new Array(synthAmt).fill().map(() =>
            ({
                pos: {
                    x: 0, y: 0, z: 0
                },
                rot: {
                    x: 0, y: Math.PI, z: 0
                },
                scale: 0,
            })
        ),
        cursors: startCursors,
        pointerDown: false,
        mode: startMode, scale: 1, length: 4, fov: 75, noteIndex: 170, started: false, delay: 0.4, hoovering: -1,
    },
    tone: {
        init: function () {
            let tone = get().tone
            get().tone.inst.map((inst, i) => {
                inst.volume.value = -12
            })
        },
        inst: new Array(synthAmt).fill().map((v,i) => i % 2 === 0 ? synthL : synthR),
    },
    isMobile: window.innerWidth < 700,
    camera: null,
    ray: new THREE.Raycaster(),
    api: {
        set: (key, data) => set((state) => { return { [key]: data } })
    },
}))

export default useStore